module.exports = "data:text/x-markdown;base64,Q29uZ3JhdHVsYXRpb25zISBJZiB5b3Ugc29sdmVkIHRoaXMgbGV2ZWwsIGNvbnNpZGVyIHlvdXJzZWxmIGEgTWFzdGVyIG9mIHRoZSBVbml2ZXJzZS4gCgpHbyBhaGVhZCBhbmQgcGllcmNlIGEgcmFuZG9tIG9iamVjdCBpbiB0aGUgcm9vbSB3aXRoIHlvdXIgTWFnbnVtIGxvb2suIE5vdywgdHJ5IHRvIG1vdmUgaXQgZnJvbSBhZmFyOyBZb3VyIHRlbGVraW5lc2lzIGhhYmlsaXRpZXMgbWlnaHQgaGF2ZSBqdXN0IHN0YXJ0ZWQgd29ya2luZy4K"


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/magicnum_complete.md
// module id = 1392
// module chunks = 0